import React, { useState, useEffect } from 'react';
import { fetchCallById } from '../../api/client';
import formatDate from '../../utils/formatDate';
import formatDuration from '../../utils/formatDuration';

export default function CallDetail({ callId, onClose }) {
  const [call, setCall] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!callId) return;
    setLoading(true);
    fetchCallById(callId)
      .then((res) => { setCall(res.data); setError(null); })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [callId]);

  if (!callId) return null;
  if (loading) return <div className="card loading">Loading call details...</div>;
  if (error) return <div className="card error-message">{error}</div>;
  if (!call) return null;

  const { summary } = call;

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3>Call Detail: {call.call_id}</h3>
        <button className="btn-secondary" onClick={onClose}>Close</button>
      </div>

      <div className="grid grid-4" style={{ marginBottom: '1rem' }}>
        <div>
          <strong>Date:</strong> {formatDate(call.created_at)}
        </div>
        <div>
          <strong>Duration:</strong> {formatDuration(call.duration)}
        </div>
        <div>
          <strong>Phone:</strong> {call.phone_number || '—'}
        </div>
        <div>
          <strong>Sentiment:</strong>{' '}
          <span className={`badge badge-${summary?.sentiment?.label || 'neutral'}`}>
            {summary?.sentiment?.label} ({summary?.sentiment?.score})
          </span>
        </div>
      </div>

      {summary?.key_points?.length > 0 && (
        <div style={{ marginBottom: '1rem' }}>
          <strong>Key Points:</strong>
          <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
            {summary.key_points.map((kp, i) => (
              <li key={i}>
                <span className="badge badge-neutral">{kp.category}</span>{' '}
                {kp.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {summary?.callback_detection?.detected && (
        <div style={{ marginBottom: '1rem' }}>
          <strong>Callback Detected:</strong>{' '}
          Confidence {Math.round(summary.callback_detection.confidence * 100)}%
          {summary.callback_detection.phone_numbers?.length > 0 && (
            <span> — Phone: {summary.callback_detection.phone_numbers.join(', ')}</span>
          )}
        </div>
      )}

      <div>
        <strong>Transcript:</strong>
        <div style={{
          marginTop: '0.5rem',
          padding: '1rem',
          background: '#f8fafc',
          borderRadius: '8px',
          fontSize: '0.9rem',
          lineHeight: '1.8',
          maxHeight: '300px',
          overflowY: 'auto',
        }}>
          {call.transcript || 'No transcript available.'}
        </div>
      </div>
    </div>
  );
}
